<template>
  <div class="partners">
    <child-header bg="yellow" v-bind:title="title" v-bind:main="main"></child-header>
    <div class="no-data" v-if="nodata">{{ noDataMessage }}</div>
    <div class="list">
      <ul class="people_info">
        <li v-for="item in items">
          <div class="person_info_left">
            <span></span>
          </div>
          <div class="person_info_right">
            <div class="person_iphone">
              {{ item.tradeaiderPhone === '' ? item.tradeaiderEmail : item.tradeaiderPhone }}
            </div>
            <div class="person_time">{{ item.ctime | date(4) }}</div>
          </div>
        </li>
      </ul>
      <div slot="bottom" class="mint-loadmore-bottom">
        <!--<span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
              <span v-show="bottomStatus === 'loading'">
                  <mt-spinner type="snake"></mt-spinner> 数据正在加载中，请稍候......
              </span>-->
      </div>
      <div v-if="end" class="endtext">------ 我是有底线的 ------</div>
      <!-- <div class="loadmore" v-if="allLoaded" @click="loadBottom">加载更多</div> -->
    </div>
  </div>
</template>

<script>
import ChildHeader from '../components/ChildHeader'
import PartnerApi from '../api/partner'
import storage from '../utils/storage'

export default {
  name: 'partners',
  components: {
    ChildHeader
  },
  data() {
    return {
      title: '我的成员',
      main: '',
      pageIndex: 1,
      pageSize: 8,
      bottomStatus: '',
      nodata: false,
      end: false,
      allLoaded: false,
      noDataMessage: '----- 没有消息 -----',
      items: [],
      userinfo: storage.getLocalStorage('userinfo')
    }
  },
  created: function() {
    PartnerApi.getUserInvite(this.userinfo.id).then(
      response => {
        let returnData = response.data
        if (returnData.success) {
          if (returnData.length === 0) {
            this.nodata = true
          }
          this.items = returnData.data
          console.log(this.items)
        }
      },
      response => {
        console.log('error')
      }
    )
  },
  mounted: function() {
    this.main = this.userinfo.totalUser + ''
    console.log(this.userinfo)
  },
  methods: {
    handleBottomChange(status) {
      this.bottomStatus = status
    }
  }
}
</script>

<style scoped>
@media (max-width: 750px) {
  .partners {
    height: 100%;
  }

  .partners .list {
    height: 100%;
  }

  .people_info li {
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    height: 3.968rem;
    list-style: none;
    border-bottom: 0.0426rem solid rgb(238, 236, 240);
  }

  .person_info_left {
    float: left;
    position: relative;
    height: 100%;
    width: 1.1946rem;
    border-right: 0.0426rem solid rgb(238, 236, 240);
  }

  .person_info_left span {
    display: block;
    width: 0.384rem;
    height: 0.384rem;
    background: #f8b62d;
    border-radius: 50%;
    position: absolute;
    top: 1.792rem;
    right: -0.192rem;
  }

  .person_info_right {
    box-sizing: border-box;
    float: left;
    width: 14.8053rem;
    padding-left: 0.7893rem;
    padding-top: 1.0666rem;
  }

  .person_info_right .person_iphone {
    box-sizing: border-box;
    font-size: 0.5973rem;
    text-align: left;
    color: #1d1d26;
  }

  .person_info_right .person_time {
    font-size: 0.512rem;
    color: #9b9b9b;
  }

  .person_state {
    font-size: 0.5973rem;
    float: right;
    text-align: right;
    width: 5.55rem;
  }
  .no-data,
  .endtext,
  .loadmore {
    font-size: 0.6rem;
    margin: 0.5rem 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
}
@media (min-width: 750px) {
  .people_info {
    background: #faf8fb;
  }
  .partners {
    position: relative;
    height: 100%;
    /*overflow-y: scroll;*/
  }

  .partners .list {
    height: 100%;
  }

  .people_info li {
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    height: 186px;
    list-style: none;
    border-bottom: 2px solid rgb(238, 236, 240);
  }

  .person_info_left {
    float: left;
    position: relative;
    height: 100%;
    width: 57px;
    border-right: 2px solid rgb(238, 236, 240);
  }

  .person_info_left span {
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #f8b62d;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -10px;
    margin-right: -10px;
  }

  .person_info_right {
    box-sizing: border-box;
    float: left;
    height: 100%;
    padding-left: 37px;
    padding-top: 55px;
    overflow: hidden;
  }

  .person_iphone {
    box-sizing: border-box;
    font-size: 28px;
    text-align: left;
    color: #1d1d26;
    margin-bottom: 5px;
  }

  .person_time {
    height: 28px;
    font-size: 24px;
    color: #9b9b9b;
  }

  .no-data,
  .endtext,
  .loadmore {
    font-size: 20px;
    margin: 20px 0;
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
  .loadmore {
    cursor: pointer;
  }
}
</style>
